import type { MeetingAgendaPointTemplate } from "@/graphql/generated-types";
import type { IMultiSelectItem, IOption } from "@/interfaces";

const toMultiSelectItem = (
  item: MeetingAgendaPointTemplate,
): IMultiSelectItem => {
  return {
    id: item.id,
    title: item.title,
    imageURL: item.picture?.source,
    blurhash: item.picture?.blurhash,
  };
};

const toOption = (item: MeetingAgendaPointTemplate): IOption => {
  return {
    value: item.id,
    title: item.title,
  };
};

export default {
  toMultiSelectItem,
  toOption,
};
